module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_dialer),
      expression: "show_dialer"
    }],
    attrs: {
      "id": "dialer"
    }
  }, [_c('div', {
    class: {
      orange: _vm.show_numbers && _vm.is_calling_on || (_vm.status == 'calling' || _vm.status == 'ended' || _vm.status == 'failed')
    },
    attrs: {
      "id": "open-dialer"
    }
  }, [(_vm.status == 'idle') ? _c('div', {
    staticClass: "close-dialer",
    on: {
      "click": _vm.close
    }
  }, [(_vm.status == "idle") ? _c('img', {
    attrs: {
      "src": require("../../assets/images/icons/fechar.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/icons/fechar-white.svg")
    }
  })]) : _vm._e(), ((_vm.show_numbers || _vm.status == 'idle') && !_vm.task.id && !_vm.contact) ? _c('contact-autocomplete', {
    attrs: {
      "from_dialer": true
    },
    on: {
      "contact-selected": _vm.selectContact
    }
  }) : _vm._e(), ((_vm.show_numbers || _vm.status == 'idle') && _vm.contact) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input_number),
      expression: "input_number"
    }],
    ref: "phone_input",
    staticClass: "phone-number",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.input_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input_number = $event.target.value
      }
    }
  }) : _vm._e(), (_vm.show_numbers || _vm.status == 'idle') ? _c('div', {
    staticClass: "btn-backspace",
    on: {
      "click": function($event) {
        return _vm.removeLastPhoneNumber()
      }
    }
  }) : _vm._e(), ((_vm.show_numbers || _vm.status == 'idle') && _vm.status != 'ended') ? _c('div', {
    staticClass: "numbers noselect",
    class: _vm.dial_css_class
  }, [_c('div', {
    staticClass: "number",
    on: {
      "click": function($event) {
        return _vm.insertPhoneNumber("1")
      }
    }
  }, [_vm._v("1")]), _c('div', {
    staticClass: "number",
    on: {
      "click": function($event) {
        return _vm.insertPhoneNumber("2")
      }
    }
  }, [_vm._v("2")]), _c('div', {
    staticClass: "number",
    on: {
      "click": function($event) {
        return _vm.insertPhoneNumber("3")
      }
    }
  }, [_vm._v("3")]), _c('div', {
    staticClass: "number",
    on: {
      "click": function($event) {
        return _vm.insertPhoneNumber("4")
      }
    }
  }, [_vm._v("4")]), _c('div', {
    staticClass: "number",
    on: {
      "click": function($event) {
        return _vm.insertPhoneNumber("5")
      }
    }
  }, [_vm._v("5")]), _c('div', {
    staticClass: "number",
    on: {
      "click": function($event) {
        return _vm.insertPhoneNumber("6")
      }
    }
  }, [_vm._v("6")]), _c('div', {
    staticClass: "number",
    on: {
      "click": function($event) {
        return _vm.insertPhoneNumber("7")
      }
    }
  }, [_vm._v("7")]), _c('div', {
    staticClass: "number",
    on: {
      "click": function($event) {
        return _vm.insertPhoneNumber("8")
      }
    }
  }, [_vm._v("8")]), _c('div', {
    staticClass: "number",
    on: {
      "click": function($event) {
        return _vm.insertPhoneNumber("9")
      }
    }
  }, [_vm._v("9")]), _c('div', {
    staticClass: "number padding-top",
    on: {
      "click": function($event) {
        return _vm.insertPhoneNumber("*")
      }
    }
  }, [_vm._v("*")]), _c('div', {
    staticClass: "number",
    on: {
      "click": function($event) {
        return _vm.insertPhoneNumber("0")
      }
    }
  }, [_vm._v("0")]), _c('div', {
    staticClass: "number",
    on: {
      "click": function($event) {
        return _vm.insertPhoneNumber("#")
      }
    }
  }, [_vm._v("#")])]) : _vm._e(), _c('div', {
    staticClass: "clear"
  }), (_vm.contact && _vm.status != 'idle' && !_vm.show_numbers) ? _c('div', {
    staticClass: "contact-info",
    class: _vm.status
  }, [_c('div', {
    staticClass: "contact-name",
    on: {
      "click": function($event) {
        return _vm.openContact(_vm.contact.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.contact.full_name))]), _c('div', {
    staticClass: "contact-company"
  }, [_vm._v(_vm._s(_vm.contact.business.name))]), _c('div', {
    staticClass: "contact-phone",
    class: _vm.status
  }, [_c('div', {
    staticClass: "contact-number"
  }, [_vm._v("+" + _vm._s(_vm.phone_number))]), _c('div', {
    staticClass: "contact-number-type"
  }, [_vm._v(_vm._s(_vm.human_number_type))])])]) : _vm._e(), (_vm.status == "calling" && !_vm.show_numbers) ? _c('div', {
    staticClass: "ringing-balls"
  }, [_c('div', {
    staticClass: "ball first"
  }), _c('div', {
    staticClass: "ball second"
  }), _c('div', {
    staticClass: "ball last"
  })]) : _vm._e(), (_vm.status != "idle" && !_vm.show_numbers) ? _c('div', {
    staticClass: "timer",
    class: _vm.status
  }, [(_vm.status != "calling") ? _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.timer))]) : _vm._e(), (_vm.status != "idle" && !_vm.show_numbers) ? _c('div', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.human_status))]) : _vm._e(), _c('div', {
    staticClass: "fail-reason",
    class: _vm.status
  }, [_vm._v(_vm._s(_vm.human_fail_reason))])]) : _vm._e(), _c('div', {
    staticClass: "clear"
  }), (_vm.show_call_status_options) ? _c('div', {
    staticClass: "call-status-options",
    class: _vm.status
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Defina um status para a tarefa:")]), _c('a', {
    staticClass: "call-status-option",
    class: {
      active: _vm.call_status == "no_connection"
    },
    on: {
      "click": function($event) {
        return _vm.setCallStatus("no_connection")
      }
    }
  }, [_vm._v("Sem conexão")]), (_vm.status != "failed") ? _c('div', [_c('a', {
    staticClass: "call-status-option",
    class: {
      active: _vm.call_status == "gatekeeper"
    },
    on: {
      "click": function($event) {
        return _vm.setCallStatus("gatekeeper")
      }
    }
  }, [_vm._v("Gatekeeper")]), _c('a', {
    staticClass: "call-status-option",
    class: {
      active: _vm.call_status == "opportunity"
    },
    on: {
      "click": function($event) {
        return _vm.setCallStatus("opportunity")
      }
    }
  }, [_vm._v("Conectado")]), _c('a', {
    staticClass: "call-status-option",
    class: {
      active: _vm.call_status == "client"
    },
    on: {
      "click": function($event) {
        return _vm.setCallStatus("client")
      }
    }
  }, [_vm._v("Cliente")]), _c('a', {
    staticClass: "call-status-option",
    class: {
      active: _vm.call_status == "lost"
    },
    on: {
      "click": function($event) {
        return _vm.setCallStatus("lost")
      }
    }
  }, [_vm._v("Perdido")])]) : _vm._e(), _c('div', {
    staticClass: "clear"
  }), _c('hr'), (_vm.contact && _vm.contact.tags) ? _c('div', {
    staticClass: "tags"
  }, [_c('div', {
    staticClass: "sidebar-menu-title"
  }, [_vm._v("Tags")]), _vm._l((_vm.contact.tags), function(tag, index) {
    return _c('tag', {
      attrs: {
        "tag": tag,
        "deletable": true
      },
      on: {
        "remove-tag": _vm.removeTag
      }
    })
  }), (!_vm.current_user.isMonitoringManager()) ? _c('div', {
    staticClass: "clickable inline",
    on: {
      "click": function($event) {
        return _vm.openTagsModal()
      }
    }
  }, [(_vm.contact.tags.length == 0) ? _c('span', [_vm._v("Adicionar Tags")]) : _vm._e(), _c('div', {
    staticClass: "add-tags-btn glyphicon glyphicon-plus text-gray-color"
  })]) : _vm._e()], 2) : _vm._e(), _c('hr'), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "btn btn-clean btn-new-task",
    on: {
      "click": function($event) {
        return _vm.openTaskModalForm()
      }
    }
  }, [_vm._v("Nova Tarefa")]), (_vm.contact) ? _c('div', {
    staticClass: "dropdown"
  }, [_vm._m(0), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.reset(_vm.input_number, _vm.phone_number_type)
      }
    }
  }, [_vm._v("Mesmo número")])]), (_vm.contact.telephone) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.reset(_vm.default_country_preffix + _vm.contact.telephone, "telephone")
      }
    }
  }, [_vm._v("Telefone " + _vm._s(_vm.contact.telephone))])]) : _vm._e(), (_vm.contact.cellphone) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.reset(_vm.default_country_preffix + _vm.contact.cellphone, "cellphone")
      }
    }
  }, [_vm._v("Celular " + _vm._s(_vm.contact.cellphone))])]) : _vm._e(), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.reset(null, "")
      }
    }
  }, [_vm._v("Novo número")])])])]) : _vm._e(), _c('div', {
    staticClass: "clear"
  }), _c('a', {
    staticClass: "finish-link",
    on: {
      "click": function($event) {
        return _vm.saveCallContact(false)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-ok"
  }), _c('span', [_vm._v("Finalizar Tarefa")])])]) : _vm._e(), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "bottom-buttons"
  }, [(_vm.show_numbers && _vm.is_calling_on) ? _c('div', {
    staticClass: "btn-back",
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icons/back-white.svg")
    }
  })]) : _vm._e(), (_vm.is_calling_on && !_vm.show_numbers) ? _c('div', {
    staticClass: "btn-show-numbers",
    on: {
      "click": function($event) {
        _vm.show_numbers = true
      }
    }
  }, [(_vm.status == "calling") ? _c('img', {
    attrs: {
      "src": require("../../assets/images/icons/teclado-dial-minimizado-white.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/icons/teclado-dial-minimizado.svg")
    }
  })]) : _vm._e(), (_vm.is_calling_on) ? _c('div', {
    staticClass: "btn-hangup",
    on: {
      "click": function($event) {
        return _vm.hangupCall()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-earphone"
  })]) : _vm._e(), (_vm.status == "idle") ? _c('div', {
    staticClass: "btn-call",
    on: {
      "click": function($event) {
        return _vm.startCall()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-earphone"
  })]) : _vm._e(), (_vm.is_calling_on && !_vm.muted) ? _c('div', {
    staticClass: "btn-mute unmuted",
    on: {
      "click": function($event) {
        return _vm.toggleMute()
      }
    }
  }, [(_vm.status == 'calling' || _vm.show_numbers) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/icons/iconemuteoff.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/icons/mutecinza.svg")
    }
  })]) : _vm._e(), (_vm.is_calling_on && _vm.muted) ? _c('div', {
    staticClass: "btn-mute muted",
    on: {
      "click": function($event) {
        return _vm.toggleMute()
      }
    }
  }, [(_vm.status == 'calling' || _vm.show_numbers) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/icons/iconemuteon.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/icons/muteonorange.svg")
    }
  })]) : _vm._e()]), (_vm.show_contact_button) ? _c('div', {
    staticClass: "btn-contact btn-bottom",
    class: _vm.status,
    on: {
      "click": _vm.toggleTaskBar
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icons/contatos.svg")
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "btn-comments btn-bottom",
    class: _vm.status,
    on: {
      "click": function($event) {
        return _vm.newComment(true)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icons/comentarios.svg")
    }
  })])], 1), _c('div', {
    attrs: {
      "id": "minimized-dialer"
    }
  }), (_vm.show_lost_reason_modal) ? _c('lost-reason-modal', {
    staticStyle: {
      "top": "0",
      "left": "102%"
    },
    attrs: {
      "contact": _vm.contact,
      "temp_attr": _vm.temp_attr
    },
    on: {
      "close-lost-reason-modal": function($event) {
        return _vm.closeLostReasonModal()
      },
      "update-contact-recipient": _vm.updateLostContact
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-button btn-primary btn-new-try",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Nova Tentativa"), _c('span', {
    staticClass: "glyphicon glyphicon-menu-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c9fb9006!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/dialer.vue
// module id = 1213
// module chunks = 1